/**
 * Created by mauget on 12/26/15.
 * AlignmentController.js
 */

import $                from 'jquery';
import BaseController   from 'BaseController.js';
import constants        from 'Constants.js';
import textConstants    from 'TextConstants.js';
import listService      from 'ListService.js';
import util             from 'util/Util.js';
import _                from 'lodash';
import undoService      from 'UndoService';
import ConnectionTracker from 'ConnectionTracker';

//======================================================================================
// Handles all alignment requests by working with controls' position properites:
// left and top. The 'objs' parameter is assumed to be an Immutable.Map of
// BaseControlView objects: (view, domId);
//
// TODO: filter algorithms by current number
//
// December 26, 2015
//======================================================================================
class AlignmentController extends BaseController {


    //===============================================================================
    // Helper: returns leftmost view from parameter immutable  map of  (v, k)
    //===============================================================================
    findLeftmost( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const left = Number(view.model.get('left'));
            if (! result || left < Number(result.model.get('left'))) {
                result = view
            }
        });
        return result;
    }

    canvasFindLeftmost( list ) {
        let leftMostPixel = listService.fcanvas.width;
        list.forEach(o=>{
            if ( o.left < leftMostPixel ) {
                leftMostPixel = o.left;
            }
        });
        return leftMostPixel;
    }


    //===============================================================================
    // Sets "left" attribute to the leftmost "left" value of immutable map of (v, k)
    // where "v' is a BackBone view of a PerfectForms control instance.
    //===============================================================================
    alignLeft( objs ) {
        const leftmost = this.findLeftmost( objs );
        let undoElements=[];
        if ( leftmost ) {
            const leftPos = Number(leftmost.model.get('left'));
            objs.map( (view, domId) => {
                undoElements.push(Number(view.model.get('left')));
                view.model.set('left', leftPos,{silent:true});
                view.render();
            });
        }
        undoService.add({
            undo:()=>{
              // Adjust all controls to have each rightmost === rmRight
              let index=0;
              objs.map( (view, domId) => {
                view.model.set('left', undoElements[index],{silent:true});
                view.model.resetLastState();
                view.render();
                index++;
              });
            },
            redo:()=>{
              undoElements=[];
              const leftPos = Number(leftmost.model.get('left'));
              objs.map( (view, domId) => {
                undoElements.push(Number(view.model.get('left')));
                view.model.set('left', leftPos,{silent:true});
                view.model.resetLastState();
                view.render();
              });
            }
        },textConstants.UNDO_ALIGN_LEFT);
        return objs;
    }

    //===============================================================================
    // Sets "left" attribute to all the controls inside the fabricJs canvas
    // using the leftmost object as guide
    //===============================================================================
    canvasAlignLeft( objs ) {
        const leftPixel = this.canvasFindLeftmost( listService.getValidCanvasObjects(objs) );
        if ( leftPixel ) {
            this.moveObjectsHorizontal( listService.getValidCanvasObjects(objs), leftPixel, 'left');
        }
    }


    //===============================================================================
    // Helper: returns rightmost view from parameter immutable  amp of  (v, k)
    // of all controls in current page
    //===============================================================================
    findRightmost( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const width = util.extractNum( view.model.get('width') );
            const right = Number(view.model.get('left')) + width;
            if (! result || right > (Number(result.model.get('left')) + util.extractNum( result.model.get('width') )) ) {
                result = view
            }
        });
        return result;
    }

    canvasFindRightmost( list ) {
        let rightMostPixel = -listService.fcanvas.width;
        list.forEach(o=>{
            let right = o.left + util.extractNum(o.model.get('width')) ;
            if ( right > rightMostPixel ) {
                rightMostPixel = right;
            }
        });
        return rightMostPixel;
    }


    //===============================================================================
    // Sets "left" attribute off all Backbone views found in the objs parameter.
    // Result is that the right sides of those views have the rightmost value
    // found in them. Each map element is (view, domId), where the view has a model
    // attributes, "left" and "width". The width value is suffixed with "px".
    //===============================================================================
    alignRight( objs ) {
        const rightmost = this.findRightmost( objs );
        let undoElements=[];
        if ( rightmost ) {

            const rmLeft = Number(rightmost.model.get('left'));
            const rmWidth= util.extractNum( rightmost.model.get('width') );
            const rmRight = rmLeft + rmWidth;

            // Adjust all controls to have each rightmost === rmRight
            objs.map( (view, domId) => {
                //console.log(`1. ${view.model.attributes.left}`);
                undoElements.push(Number(view.model.get('left')));

                const thisRight  = Number(view.model.get('left')) + util.extractNum( view.model.get('width') );
                const thisLeft = Number(view.model.get('left')) - thisRight + rmRight;

                view.model.set('left', thisLeft,{silent:true}) ;
                view.render();
            });

            undoService.add({
                undo:()=>{
                  // Adjust all controls to have each rightmost === rmRight
                  let index=0;
                  objs.map( (view, domId) => {

                    view.model.set('left', undoElements[index],{silent:true});
                    view.model.resetLastState();
                    view.render();
                    index++;
                  });
                },
                redo:()=>{
                    const rightmost = this.findRightmost( objs );
                    const rmLeft = Number(rightmost.model.get('left'));
                    const rmWidth= util.extractNum( rightmost.model.get('width') );
                    const rmRight = rmLeft + rmWidth;
                    undoElements=[];
                    objs.map( (view, domId) => {
                      undoElements.push(Number(view.model.get('left')));

                      const thisRight  = Number(view.model.get('left')) + util.extractNum( view.model.get('width') );
                      const thisLeft = Number(view.model.get('left')) - thisRight + rmRight;

                      view.model.set('left', thisLeft,{silent:true}) ;
                      view.model.resetLastState();
                      view.render();
                  });
              }
            },textConstants.UNDO_ALIGN_RIGHT)
        }
        return objs;
    }

    canvasAlignRight( objs ) {
        const leftPixel = this.canvasFindRightmost( listService.getValidCanvasObjects(objs) );
        if ( leftPixel ) {
            this.moveObjectsHorizontal( listService.getValidCanvasObjects(objs), leftPixel, 'right');
        }
    }

    alignCenter(selectedObjects, type){
       let lowMostProp,highMostProp;
       let undoElements=[];

        // Getting the first and last controls depending the case, for calculate its middle distance.
        switch(type){
            case constants.ALIGN_VERTICAL:lowMostProp=this.findTopmost(selectedObjects).model.get(type);
                                            highMostProp=this.findBottomMost(selectedObjects).model.get(type);break;
            case constants.ALIGN_HORIZONTAL:lowMostProp=this.findLeftmost(selectedObjects).model.get(type);
                                             highMostProp=this.findRightmost(selectedObjects).model.get(type);break;
        }

        // Getting the center of the distance between the first and last controls to place them in the middle depending the case.
        const centerValue=lowMostProp + ((highMostProp-lowMostProp) / 2),
              justValues=[...selectedObjects.values()];
       justValues.forEach((item)=>{
           undoElements.push(item.model.get(type));
           const currentValue=item.model.get(type);

           // If currentValue is less than the middle we need to add pixels to the left/top property depending the case.
           if(currentValue < centerValue ){
               const substraction=centerValue - currentValue;
               const newLeftValue=currentValue + substraction;
               item.model.set(type,newLeftValue,{silent:true});
               item.render();
           }

           // If currentValue is less than the middle we need to substract pixels to the left/top property depending the case.
           else if(currentValue > centerValue ){
               const substraction=currentValue - centerValue;
               const newLeftValue=currentValue - substraction;
               item.model.set(type,newLeftValue,{silent:true});
               item.render()
           }
       });

      undoService.add({
        undo:()=>{
          // Adjust all controls to have each rightmost === rmRight
          let index=0;
          selectedObjects.map( (view, domId) => {
            view.model.set(type, undoElements[index],{silent:true});
            view.model.resetLastState();
            view.render();
            index++;
          });
        },
        redo:()=>{
          undoElements=[];
          switch(type){
            case constants.ALIGN_VERTICAL:lowMostProp=this.findTopmost(selectedObjects).model.get(type);
              highMostProp=this.findBottomMost(selectedObjects).model.get(type);break;
            case constants.ALIGN_HORIZONTAL:lowMostProp=this.findLeftmost(selectedObjects).model.get(type);
              highMostProp=this.findRightmost(selectedObjects).model.get(type);break;
          }

          // Getting the center of the distance between the first and last controls to place them in the middle depending the case.
          const centerValue=lowMostProp + ((highMostProp-lowMostProp) / 2),
              justValues=[...selectedObjects.values()];
          justValues.forEach((item)=>{
            undoElements.push(item.model.get(type));
            const currentValue=item.model.get(type);

            // If currentValue is less than the middle we need to add pixels to the left/top property depending the case.
            if(currentValue < centerValue ){
              const substraction=centerValue - currentValue;
              const newLeftValue=currentValue + substraction;
              item.model.set(type,newLeftValue,{silent:true});
              item.model.resetLastState();
              item.render();
            }

            // If currentValue is less than the middle we need to substract pixels to the left/top property depending the case.
            else if(currentValue > centerValue ){
              const substraction=currentValue - centerValue;
              const newLeftValue=currentValue - substraction;
              item.model.set(type,newLeftValue,{silent:true});
              item.model.resetLastState();
              item.render();
            }
          });
        }
      },textConstants.UNDO_ALIGN_TOP);
    }

    canvasAlignCenter( type, objs ) {
        let lowMostProp,highMostProp;
        let validObjs = listService.getValidCanvasObjects(objs);

        // Getting the first and last controls depending the case, for calculate its middle distance.
        switch(type){
            case constants.ALIGN_VERTICAL:
                lowMostProp = this.canvasFindLeftmost(validObjs);
                highMostProp = this.canvasFindRightmost(validObjs);
                break;
            case constants.ALIGN_HORIZONTAL:
                lowMostProp = this.canvasFindBottomMost(validObjs);
                highMostProp = this.canvasFindTopmost(validObjs);
                break;
            default:
                break;
        }

        const centerValue = lowMostProp + ((highMostProp-lowMostProp) / 2);

        // Getting the center of the distance between the first and last controls to place them in the middle depending the case.
        const justValues=[...validObjs.values()];

        validObjs.forEach((item)=>{

            let newLeftValue;
            const currentValue = item[type];
            let addingValue, sizeValue = 0;

            if (type === constants.ALIGN_VERTICAL) {
                sizeValue = util.extractNum(item.model.get('width')) / 2;
            } else {
                sizeValue = util.extractNum(item.model.get('height')) / 2;
            }
            // If currentValue is less than the middle we need to add pixels to the left/top property depending the case.
            if( currentValue < centerValue ){
                newLeftValue = currentValue + (centerValue - currentValue) - sizeValue;
            } else if( currentValue > centerValue ) { // If currentValue is less than the middle we need to substract pixels to the left/top property depending the case.
                newLeftValue = currentValue - (currentValue - centerValue) -sizeValue;
            }

            item.animate(type, newLeftValue, {
                duration: 500,
                onChange: listService.fcanvas.renderAll.bind(listService.fcanvas),
                easing: fabric.util.ease['easeOutQuad']
            });

            let newPositionValue = newLeftValue;
            let coord;
            if (type === constants.ALIGN_VERTICAL) {
                newPositionValue = newLeftValue + (item.originalLeft-item.left);
                coord = 'x';
            } else if (type === constants.ALIGN_HORIZONTAL) {
                newPositionValue = newLeftValue + (item.originalTop-item.top);
                coord = 'y';
            }
            item.model.set(coord, newPositionValue, {silent: true});
            item.set({type: newLeftValue});

            const delta = { dx: item.model.get('x')- item.originalLeft,  dy: item.model.get('y')- item.originalTop };
            item.set({'originalLeft': item.model.get('x')});
            item.set({'originalTop': item.model.get('y')});
            _.forEach(item.connection, conn => ConnectionTracker.moveEndOfConnection( conn, delta ) );

        });
        listService.fcanvas.renderAll();
    }


    //===============================================================================
    // Helper: returns find topmost view from parameter immutable  map of  (v, k)
    //===============================================================================
    findTopmost( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const top = Number(view.model.get('top'));
            if ( !result || top < Number(result.model.get('top')) ) {
                result = view
            }
        });
        return result;
    }

    canvasFindTopmost( objs ) {
        let topPixel = listService.fcanvas.height;

        objs.forEach(o=>{
            if ( o.top < topPixel ) {
                topPixel = o.top;
            }
        });
        return topPixel;
    }

    canvasAlignTop( objs ) {
        const topPixel = this.canvasFindTopmost(listService.getValidCanvasObjects(objs));
        if ( topPixel ) {
            this.moveObjectsVertical( listService.getValidCanvasObjects(objs), topPixel, 'top');
        }
    }

    //===============================================================================
    // Sets "top" attribute to the topmost "top" value of immutable map of (v, k)
    // where "v' is a BackBone view of a PerfectForms control instance.
    //===============================================================================
    alignTop( objs ) {
        const topmost = this.findTopmost( objs );
        let undoElements=[];
        if ( topmost ) {
            const topPos = Number(topmost.model.get('top'));
            objs.map( (view, domId) => {
                undoElements.push(Number(view.model.get('top')));
                view.model.set('top', topPos,{silent:true}) ;
                view.render();
            });
        }
      undoService.add({
        undo:()=>{
          // Adjust all controls to have each rightmost === rmRight
          let index=0;
          objs.map( (view, domId) => {

            view.model.set('top', undoElements[index],{silent:true});
            view.model.resetLastState();
            view.render();
            index++;
          });
        },
        redo:()=>{
            const topPos = Number(topmost.model.get('top'));
            objs.map( (view, domId) => {
              undoElements.push(Number(view.model.get('top')));
              view.model.set('top', topPos,{silent:true}) ;
              view.model.resetLastState();
              view.render();
            });
        }
      },textConstants.UNDO_ALIGN_TOP);

        return objs;
    }


    //===============================================================================
    // Helper: returns findBottomMost view from parameter immutable  amp of  (v, k)
    //===============================================================================
    findBottomMost( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const height = util.extractNum( view.model.get('height') );
            const bottom = Number(view.model.get('top')) + height;
            if (! result || bottom > (Number(result.model.get('top')) + util.extractNum( result.model.get('height') )) ) {
                result = view
            }
        });
        return result;
    }

    canvasFindBottomMost( objs ) {
        let bottomPixel = -listService.fcanvas.height;
        objs.forEach(o=>{
            let bottom = o.top + util.extractNum(o.model.get('height')) ;
            if ( bottom > bottomPixel ) {
                bottomPixel = bottom;
            }
        });
        return bottomPixel;
    }

    //===============================================================================
    // Sets "top" attribute of all Backbone views found in the objs parameter.
    // Result is that the bottom sides of those views have the bottommost value
    // found in them. Each map element is (view, domId), where the view has a model
    // attributes, "top" and "height". The height value is suffixed with "px".
    //===============================================================================
    alignBottom( objs ) {
        const bottomMost = this.findBottomMost( objs );
        let undoElements=[];
        if ( bottomMost ) {

            const bmTop = Number(bottomMost.model.get('top'));
            const bmHeight = util.extractNum( bottomMost.model.get('height') );
            const bmBottom = bmTop + bmHeight;

            // Aajust all controls to have each rightmost === rmRight
            objs.map( (view, domId) => {
                undoElements.push(Number(view.model.get('top')));
                const thisBottom  = Number(view.model.get('top')) + util.extractNum( view.model.get('height') );
                const thisTop = Number(view.model.get('top')) - thisBottom + bmBottom;

                view.model.set('top',thisTop,{silent:true});
                view.model.resetLastState();
                view.render();
            });

          undoService.add({
            undo:()=>{
              // Adjust all controls to have each rightmost === rmRight
              let index=0;
              objs.map( (view, domId) => {

                view.model.set('top', undoElements[index],{silent:true});
                view.model.resetLastState();
                view.render();
                index++;
              });
            },
            redo:()=>{
              objs.map( (view, domId) => {
                undoElements.push(Number(view.model.get('top')));
                const thisBottom  = Number(view.model.get('top')) + util.extractNum( view.model.get('height') );
                const thisTop = Number(view.model.get('top')) - thisBottom + bmBottom;

                view.model.set('top',thisTop,{silent:true}) ;
                view.model.resetLastState();
                view.render();
              });
            }
          },textConstants.UNDO_ALIGN_BOTTOM);
        }
        return objs;
    }

    canvasAlignBottom( objs ) {
        const bottomPixel = this.canvasFindBottomMost( listService.getValidCanvasObjects(objs) );
        if ( bottomPixel ) {
            this.moveObjectsVertical( listService.getValidCanvasObjects(objs), bottomPixel, 'bottom');
        }
    }

    //===============================================================================
    // Helper: returns widest view from parameter immutable  amp of  (v, k)
    //===============================================================================
    findWidest( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const width = util.extractNum( view.model.get('width') );
            if (! result || width > util.extractNum( result.model.get('width') ) ) {
                result = view
            }
        });
        return result;
    }

    canvasFindWidest( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const width = util.extractNum( view.get('width') );
            if (! result || width > util.extractNum( result.get('width') ) ) {
                result = view
            }
        });
        return result;
    }

    //===============================================================================
    // Sets "width" of all Backbone views found in the objs parameter. Result is
    // the value of the maximum width found in those views. Note that the width
    // attribute is a string suffixed with 'px';
    //===============================================================================
    makeSameWidth( objs ) {
        const widestView = this.findWidest( objs );
        if ( widestView ) {
            const widestPx = widestView.model.get('width');
            objs.map( (view, domId) => {
                view.model.set('width', widestPx);
                $( constants.ID_SEL + domId ).css('width', widestPx);
            });
        }
        return objs;
    }

    canvasMakeSameWidth( objs ) {
        const widestView = this.canvasFindWidest( listService.getValidCanvasObjects(objs) );
        if ( widestView ) {
            const widestPx = widestView.get('width');
            const objectsToResize = listService.getValidCanvasObjects(objs).filter(o=>{ return o.model.get('id') !== widestView.model.get('id'); });
            objectsToResize.map( (view, domId) => {
                view.model.set('width', widestPx-(10));
                view.set('width', widestPx-(10));
            });
            listService.fcanvas.trigger('mouse:down').trigger('mouse:up').deactivateAll().renderAll();
        }
    }

    //===============================================================================
    // Helper: returns highest view from parameter immutable  amp of  (v, k)
    //===============================================================================
    findHighest( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const height = util.extractNum( view.model.get('height') );
            if (! result || height > util.extractNum( result.model.get('height') ) ) {
                result = view
            }
        });
        return result;
    }

    canvasFindHighest( objs ) {
        let result = undefined;
        objs.map( (view, domId) => {
            const height = util.extractNum( view.get('height') );
            if (! result || height > util.extractNum( result.get('height') ) ) {
                result = view
            }
        });
        return result;
    }


    //===============================================================================
    // Sets "height" of all Backbone views found in the objs parameter. Result is
    // the value of the maximum height found in those views. Note that the height
    // attribute is a string suffixed with 'px';
    //===============================================================================
    canvasMakeSameHeight( objs ) {
        const highestView = this.canvasFindHighest( listService.getValidCanvasObjects(objs) );
        if ( highestView ) {
            const highestPx = highestView.get('height');
            const objectsToResize = listService.getValidCanvasObjects(objs).filter(o=>{ return o.model.get('id') !== highestView.model.get('id'); });
            objectsToResize.map( (view, domId) => {
                view.model.set('height', highestPx-(view.model.get('factoryKey')==='workflow_stage' ? 0:10));
                view.set('height', highestPx-(view.model.get('factoryKey')==='workflow_stage' ? 0:10));
            });
            listService.fcanvas.trigger('mouse:down').trigger('mouse:up').deactivateAll().renderAll();
        }
    }

    makeSameHeight( objs ) {
        const highestView = this.findHighest( objs );
        if ( highestView ) {
            const highestPx = highestView.model.get('height');
            objs.map( (view, domId) => {
                view.model.set('height', highestPx);
                $( constants.ID_SEL + domId ).css('height', highestPx);
            });
        }
        return objs;
    }


    sortByZOrderAsc(objs, numericSort=false ) {
        const ascComparator = ( view1, view2 ) => {
            let z1 = view1.model.attributes.zOrder;
            let z2 = view2.model.attributes.zOrder;
            if (numericSort) {
                z1 = Number(z1);
                z2 = Number(z2);
            }
            return z1 < z2 ? -1 : (z1 === z2 ? 0 : 1);

        }
        return objs.sort( ascComparator );
    }


    sortByZOrderDsc(objs ) {
        const ascComparator = ( view1, view2 ) => {
            const z1 = Number(view1.model.attributes.zOrder);
            const z2 = Number(view2.model.attributes.zOrder);
            return z1 < z2 ? 1 : (z1 === z2 ? 0 : -1);

        }
        return objs.sort( ascComparator );
    }

    //===================================================================================================
    // Send selected objects to defined minimum z-index
    //
    // Note: css layer attribute name is z-index. Model attribute name is zIndex.
    //===================================================================================================
    toBottom( selectedObjs ) {

        selectedObjs.map( (view, domId) => {

            // Update zOrder of view on master object list
            view.model.set('zOrder', constants.MIN_Z_INDEX, {silent: true});
            // PF-8474 : Create object to send options needed to update view
            const opt = {evt: 'UPDATE', index: constants.MIN_Z_INDEX};
            // Send opt as third parameter
            listService.updateObject( domId, view, opt );

            // Update the rendering z-index  -- the visible
            $( `${constants.ID_SEL}${domId}` ).css('z-index', constants.MIN_Z_INDEX);
        });


        return selectedObjs;
    }



    //===================================================================================================
    // 1. Sort a copy of entire object list sorted descending (later, limit list to controls in page)
    // 2. Use first item (top zOrder) value to assign new zOrder to selected objs, trending upward.
    // 3. Set CSS z-index .for each view from it's zOrder
    //
    // This is simpler than toBottom because no change oft z-order going below the z-index of the
    // page itself.
    //
    // Caveat: repeated use of this algorithm creates gaps in the z-order. We'll fix this by callling
    // another method to de-gas the object list z-order.
    //
    // Note: css layer attribute name is z-index. Model attribute name is zIndex.
    //===================================================================================================
    toTop( selectedObjs ) {

        const sortedList = this.sortByZOrderDsc( listService.objectList );
        const topView = sortedList.first();

        let acc = Number(topView.model.get('zOrder') );

        // Send only objects in selection list beyond the topmost layer(s)
        selectedObjs.map( (view, domId) => {
            console.log(domId);

            // Update view on master object list
            // PF-8474 : create opt object to send options needed to update view
            const zOrder = ++acc;
            view.model.set('zOrder', zOrder, {silent: true});
            const opt = {evt: 'UPDATE', index: zOrder};
            listService.updateObject( domId, view, opt );

            // Update the rendered -- the visible
            $( constants.ID_SEL + domId ).css('z-index', view.model.get('zOrder') );
        });

    }
    layerElement( selectedObjs ,type) {
        let sortedList;

        // Depending on the layering type we get the list of items either ordered ascending or descending.
        switch(type){
            case constants.LAYER_UP:sortedList=this.sortByZOrderAsc(listService.objectList);break;
            case constants.LAYER_DOWN:sortedList=this.sortByZOrderDsc(listService.objectList);break;
           default:sortedList=this.sortByZOrderDsc(listService.objectList);break;            
        }
        // Getting just the values of the sorted and selected maps.
        let justSelectedValues=[...selectedObjs.values()];
        let justSortedValues=[...sortedList.values()];
        let justSortedLength=justSortedValues.length;

        // Pushing the index that the selected items have in the selected values array into a new array.
        let elementsToLayoutIndex=justSelectedValues.reduce((accum,elem,index) => {
            if(justSortedValues.indexOf(elem) > -1){
                accum.push(justSortedValues.indexOf(elem));
            }
            return accum;
        },[]);

        // Going over each of the indexes stored.
            elementsToLayoutIndex.forEach((item,index) => {
                // If we reach the end stop.
                if(index === justSortedLength - 2){
                    return;
                }

                // Otherwise get the current element zIndex and the next one of the sorted list thanks to the index stored.
                let currentElement=justSortedValues[item];
                let nextElement=justSortedValues[item + 1];
                let previousZIndex=currentElement.model.get('zOrder');
                let nextZIndex=nextElement.model.get('zOrder');

                //Interchanging zIndexes.
                currentElement.model.set('zOrder',nextZIndex);
                listService.updateObject( currentElement.id, currentElement );
                $( constants.ID_SEL + currentElement.id ).css('z-index', currentElement.model.get('zOrder') );

                nextElement.model.set('zOrder',previousZIndex);
                listService.updateObject( nextElement.id, nextElement );
                $( constants.ID_SEL + nextElement.id ).css('z-index', nextElement.model.get('zOrder') );
            })
    }

    getPrepareDataForDown(selectedObjs){
        let firstElement = selectedObjs instanceof Array ? selectedObjs[0] : selectedObjs.first();
        let mostTop =  Number(firstElement.model.get('top') !== undefined ? firstElement.model.get('top') : firstElement.originalTop);
        let mostBottom = mostTop + util.extractNum(firstElement.model.get('height'));
        let totalSpace = 0, occupiedSpace = 0;
        let objsArray = [];
        selectedObjs.map((view, id)=>{
            let objTop = Number(view.model.get('top') !== undefined ? view.model.get('top'):view.originalTop);
            let objHeight = util.extractNum(view.model.get('height'));
            let objBottom = objTop + objHeight ;
            if (  objTop < mostTop ) {
                mostTop = objTop;
            }
            if (  objBottom > mostBottom ) {
                mostBottom = objBottom;
            }
            occupiedSpace += objHeight;
            objsArray.push({'id': id, 'top': objTop, 'height': objHeight});
        });
        totalSpace = mostBottom - mostTop;
        return ( {'freeSpace': totalSpace - occupiedSpace, 'mostTop': mostTop, 'mostBottom': mostBottom, 'objsArray': objsArray} );
    }

    getPrepareDataForAcross(selectedObjs){
        let firstElement = selectedObjs instanceof Array ? selectedObjs[0] : selectedObjs.first();
        let mostLeft = Number(firstElement.model.get('left') !== undefined ? firstElement.model.get('left') : firstElement.originalLeft);
        let mostRight = mostLeft + util.extractNum(firstElement.model.get('width'));
        let totalSpace = 0, occupiedSpace = 0;
        let objsArray = [];
        selectedObjs.map((view, id)=>{
            let objLeft = Number(view.model.get('left') !== undefined ? view.model.get('left') : view.originalLeft);
            let objWidth = util.extractNum(view.model.get('width'));
            let objRight = objLeft + objWidth ;
            if (  objLeft < mostLeft ) {
                mostLeft = objLeft;
            }
            if (  objRight > mostRight ) {
                mostRight = objRight;
            }
            occupiedSpace += objWidth;
            objsArray.push({'id': id, 'left': objLeft, 'width': objWidth});
        });
        totalSpace = mostRight - mostLeft;
        return ( {'freeSpace': totalSpace - occupiedSpace, 'mostLeft': mostLeft, 'mostRight': mostRight, 'objsArray': objsArray} );
    }



    spaceEvenly( selectedObjs ,type,length = 0){
       // Getting the whole space in pixels of the space between components.
        if (type === constants.EVENLY_DOWN) {
            let dataResult = this.getPrepareDataForDown(selectedObjs);
            if (dataResult.freeSpace > 0 ) {
               let evenlySpace = dataResult.freeSpace / (dataResult.objsArray.length -1);
               let sortedObjects = _.sortBy(dataResult.objsArray, 'height');
               sortedObjects = _.sortBy(sortedObjects, 'top');

                let lastPosition = Number( sortedObjects[0].top);
                let add = 0;
                _.forEach(sortedObjects, function(element, count) {
                    let view = selectedObjs.get(element.id);
                    view.model.set('top', (lastPosition + add).toString() );
                    lastPosition = Number(view.model.get('top')) + util.extractNum(view.model.get('height'));
                    add = evenlySpace;
                });
            }
        } else if (type === constants.EVENLY_ACROSS) {
            let dataResult = this.getPrepareDataForAcross(selectedObjs);
            if (dataResult.freeSpace > 0 ) {
               let evenlySpace = dataResult.freeSpace / (dataResult.objsArray.length -1);
               let sortedObjects = _.sortBy(dataResult.objsArray, 'width');
               sortedObjects = _.sortBy(sortedObjects, 'left' );

                let lastPosition = Number( sortedObjects[0].left);
                let add = 0;
                _.forEach(sortedObjects, function(element, count) {
                    let view = selectedObjs.get(element.id);
                    view.model.set('left', (lastPosition + add).toString() );
                    lastPosition = Number(view.model.get('left')) + util.extractNum(view.model.get('width'));
                    add = evenlySpace;
                });
            }
        }
    }

    // Practical duplicate of canvasSpaceEvenly method... to use canvas objects instead of designer layout elements
    canvasSpaceEvenly( type, objs, length = 0, animations={} ) {
        let validObjs = length === 0
            ? listService.getValidCanvasObjects(objs)
            : objs;

        if (type === constants.EVENLY_DOWN) {
            let dataResult = this.getPrepareDataForDown(validObjs);
            if (dataResult.freeSpace > 0 ) {
               let evenlySpace = dataResult.freeSpace / (dataResult.objsArray.length -1);
                let sortedObjects = _.sortBy(validObjs, 'model.attributes.height');
                sortedObjects = _.sortBy(sortedObjects, 'originalTop');
                let lastPosition = Number( sortedObjects[0].top);
                let add = 0;
                _.forEach(sortedObjects, function(view, count) {
                    let originalTop = view.top;
                    view.animate('top', lastPosition + add, {
                        duration: 500,
                        onChange: listService.fcanvas.renderAll.bind(listService.fcanvas),
                        easing: fabric.util.ease['easeOutQuad']
                    });
                    let moving =  lastPosition + add - originalTop;
                    view.model.set('y', (Number(view.model.get('y')) + moving).toString(), {silent: true});
                    view.set({'top': lastPosition + add});
                    const delta = { dx: 0,  dy: moving };
                    view.set({'originalLeft': Number(view.model.get('x'))});
                    view.set({'originalTop': Number(view.model.get('y'))});
                    _.forEach(view.connection, conn => ConnectionTracker.moveEndOfConnection( conn, delta ) );

                    lastPosition = view.top + util.extractNum(view.model.get('height'));
                    add = evenlySpace;
                });
            }
        } else if (type === constants.EVENLY_ACROSS) {
            let dataResult = this.getPrepareDataForAcross(validObjs);
            if (dataResult.freeSpace > 0 ) {
                let evenlySpace = dataResult.freeSpace / (dataResult.objsArray.length -1);
                let sortedObjects = _.sortBy(validObjs, 'model.attributes.width');
                sortedObjects = _.sortBy(sortedObjects, 'originalLeft');

                let lastPosition = Number( sortedObjects[0].left);
                let add = 0;
                _.forEach(sortedObjects, function(view, count) {
                    let originalLeft = view.left;
                    view.animate('left', lastPosition + add, {
                        duration: 500,
                        onChange: listService.fcanvas.renderAll.bind(listService.fcanvas),
                        easing: fabric.util.ease['easeOutQuad']
                    });
                    let moving =  lastPosition + add - originalLeft;
                    view.model.set('x', (Number(view.model.get('x')) + moving).toString(), {silent: true});
                    view.set({'left': lastPosition + add});
                    const delta = { dx: moving,  dy: 0 };
                    view.set({'originalLeft': Number(view.model.get('x'))});
                    view.set({'originalTop': Number(view.model.get('y'))});
                    _.forEach(view.connection, conn => ConnectionTracker.moveEndOfConnection( conn, delta ) );

                    lastPosition = view.left + util.extractNum(view.model.get('width'));
                    add = evenlySpace;
                });
            }
        }
    }

    //===================================================================================================
    // Move all objects on the horizontal plane
    // objects: stages+comments+lines
    //===================================================================================================
    moveObjectsHorizontal( objects, newPosition, direction ) {
        let calculatedPosition = newPosition;
        const $canvas = $('div.canvas-container');

        $canvas.addClass('disabledSection');
        objects.forEach((o, index)=>{
            if (direction === 'right') {
                calculatedPosition = newPosition - util.extractNum(o.model.get('width'));
            }
            o.animate('left', calculatedPosition, {
                duration: 500,
                onChange: listService.fcanvas.renderAll.bind(listService.fcanvas),
                easing: fabric.util.ease['easeOutQuad'],
                onComplete: function() {
                    $canvas.removeClass('disabledSection');
                }
            });
            o.model.set('x',calculatedPosition + (o.originalLeft-o.left), {silent:true});
            o.set({'left':calculatedPosition});

            const delta = { dx: o.model.get('x')- o.originalLeft,  dy: 0 };
            o.set({'originalLeft': o.model.get('x')});
            o.set({'originalTop': o.model.get('y')});
            _.forEach(o.connection, conn => ConnectionTracker.moveEndOfConnection( conn, delta ) );
        });
        listService.fcanvas.renderAll();
    }

    moveObjectsVertical( objects, newPosition, direction ) {
        let calculatedPosition = newPosition;
        const $canvas = $('div.canvas-container');
        
        $canvas.addClass('disabledSection');
        objects.forEach((o, index)=>{
            if (direction === 'bottom') {
                calculatedPosition = newPosition - util.extractNum(o.model.get('height'));
            }
            o.animate('top', calculatedPosition, {
                duration: 500,
                onChange: listService.fcanvas.renderAll.bind(listService.fcanvas),
                easing: fabric.util.ease['easeOutQuad'],
                onComplete: function() {
                    $canvas.removeClass('disabledSection');
                }
            });
            o.model.set('y',calculatedPosition + (o.originalTop-o.top),{silent: true});
            o.set({'top':calculatedPosition});

            const delta = { dx: 0,  dy: o.model.get('y')- o.originalTop };
            o.set({'originalLeft': o.model.get('x')});
            o.set({'originalTop': o.model.get('y')});
            _.forEach(o.connection, conn => ConnectionTracker.moveEndOfConnection( conn, delta ) );
        });
        listService.fcanvas.renderAll();
    }
}


const alignmentController = new AlignmentController();
export default alignmentController;
